/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useMemo } from 'react';
import Input from 'antd/lib/input';
import { FaRegCalendar } from 'react-icons/fa6';
import { formatDate } from 'src/app/utils/date-time.utils';
import { useAppContext } from 'src/app/state';
import { ActionType } from 'src/app/state/action-type.enum';
import DateTimePopupContent from './DateTimePopupContent';
import Button from '../button/Button';
import { PiPencilSimpleBold } from 'react-icons/pi';

type DateTimePickerProps = {
  showTimePicker: boolean;
  selectedDate: Date | undefined;
  minDate?: Date;
  maxDate?: Date;
  showAs?: 'input' | 'button';
  btnText?: string;
  datesDisabled?: Date[];
  vyduraEveryDayDates?: Date[];
  vyduraPerAttacksDates?: Date[];
  migraineDates?: Date[];
  showFullDateWithTime?: boolean;
  handleSelectDateTime: (date: Date) => void;
};

const DateTimePicker = ({
  showTimePicker,
  selectedDate,
  handleSelectDateTime,
  minDate,
  maxDate,
  showAs = 'input',
  btnText = '',
  datesDisabled = [],
  vyduraEveryDayDates = [],
  vyduraPerAttacksDates = [],
  migraineDates = [],
  showFullDateWithTime = true,
}: DateTimePickerProps) => {
  const {
    dispatch,
    state: { isPopUpOpened },
  } = useAppContext();

  const PopUpContent = useMemo(
    () => () => (
      <DateTimePopupContent
        showTimePicker={showTimePicker}
        selectedDate={selectedDate}
        minDate={minDate}
        maxDate={maxDate}
        handleSelectDateTime={handleSelectDateTime}
        datesDisabled={datesDisabled}
        vyduraEveryDayDates={vyduraEveryDayDates}
        vyduraPerAttacksDates={vyduraPerAttacksDates}
        migraineDates={migraineDates}
      />
    ),
    [selectedDate, showTimePicker, minDate, maxDate]
  );

  const setUpCalendar = useCallback(() => {
    dispatch({
      type: ActionType.SET_POP_UP_CONTENT,
      payload: {
        PopUpContent,
      },
    });
    dispatch({
      type: ActionType.SET_POP_UP_HEADER,
      payload: { popUpHeader: `Select day${showTimePicker ? ' & time' : ''}` },
    });
    dispatch({
      type: ActionType.SET_POP_UP_FOOTER,
      payload: {
        PopUpFooter: undefined,
      },
    });
  }, [PopUpContent, showTimePicker]);

  const handleCalendarOpen = () => {
    setUpCalendar();
    dispatch({ type: ActionType.POP_UP_OPEN, payload: {} });
  };

  return (
    <div>
      {showAs === 'input' ? (
        <Input
          size='large'
          placeholder='Select date'
          value={
            selectedDate ? formatDate(selectedDate, showFullDateWithTime) : ''
          }
          onClick={handleCalendarOpen}
          disabled={isPopUpOpened}
          suffix={<FaRegCalendar onClick={handleCalendarOpen} />}
        />
      ) : (
        <Button
          type='transparent'
          width='content-width'
          onClick={handleCalendarOpen}
          isReadOnly={isPopUpOpened}
          style={{
            fontSize: '16px',
            fontWeight: '500',
            color: 'var(--color-text-gray)',
            display: 'flex',
            alignItems: 'center',
            padding: 0,
            height: 'fit-content',
          }}
        >
          <PiPencilSimpleBold size={16.6} />
          &nbsp;&nbsp;
          {btnText}
        </Button>
      )}
    </div>
  );
};

export default DateTimePicker;
